import React, { useState, useEffect, useContext } from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid'

import { SessionContext } from "../context/session-context";

export default function MapFooter(props) {

    const useStyles = makeStyles({

        mapFooter: {
            display:"flex",
            flexDirection:"row",
            width: props.width,
            height:25,
            backgroundColor: '#FFFFFF',
            color: '#000',
            zindex: 100,
        },
        support:{
            marginTop: 5,
            marginLeft: 20,
        },
        mapCoordinates: {
            display:"flex",
            flexDirection:"row",
        },
        highlight: {
          color: '#0C4C35'
        }
      });

  const classes = useStyles();
  const [sState] = useContext(SessionContext);
  const [viewScale, setViewScale] = useState('');
  const [copyright, setCopyright] = useState(sState.copyright);
  const support_email = process.env.REACT_APP_SITE_SUPPORTEMAIL;
  const support_number = process.env.REACT_APP_SITE_SUPPORTNUMBER;

  useEffect(() => {
    setCopyright(sState.copyright);
  },[sState.copyright]);

  useEffect(() => {
    if (String(sState.viewScale) !== viewScale) setViewScale(String(sState.viewScale));
  },[sState.viewScale,viewScale]);


  return (
    <div id='mapfooter' className={classes.mapFooter}>
      <Grid container>
      <Grid item xs={5}>
        { sState.isActive ? 
        <div className={classes.support}> 
          <Box fontWeight="fontWeightBold" fontSize={12}>Support Team: <span className={classes.highlight}>{support_number}</span></Box>
          <Box fontWeight="fontWeightBold" fontSize={12}>Email: <span className={classes.highlight}>{support_email}</span></Box>
        </div>
         : '' }
      </Grid>
      <Grid item xs={3}>
          <div className={classes.mapCoordinates}>
              <Box p={1} fontSize={12}><div id='map_coordinates'/></Box>
          </div>
      </Grid>
      <Grid item xs={2}><Box p={1} fontSize={12}>View Scale 1:{viewScale}</Box></Grid>
      <Grid item xs={2}><Box p={1} fontSize={12}>{copyright}</Box></Grid>
    </Grid>
    </div>
  );
}
